import {SVGProps} from 'react';
import {APP_COLORS} from '@/const';

const AnimatedLoader = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={100} height={100} {...props}>
        <circle
            cx={50}
            cy={50}
            r={40}
            fill="none"
            stroke={APP_COLORS.main}
            strokeDasharray="62.83185307179586 62.83185307179586"
            strokeLinecap="round"
            strokeWidth={6}
        />
        <circle
            cx={50}
            cy={50}
            r={25}
            fill="none"
            stroke={APP_COLORS.shade1}
            strokeDasharray="39.269908169872416 39.269908169872416"
            strokeLinecap="round"
            strokeWidth={6}
        />
    </svg>
);

export default AnimatedLoader;
